import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentService } from 'src/app/services/shared/payment.service';

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss'],
})
export class PaymentStatusComponent implements OnInit {
  statusMessage: string = 'Processing...';
  success: boolean = false;
  paymentDetails: any = null;

  constructor(
    private route: ActivatedRoute,
    private paymentService: PaymentService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const orderId = params['order_id'];
  
      if (orderId) {
        this.paymentService.getPaymentStatus(orderId).subscribe({
          next: (data: any) => {
            console.log('data', data);
            
            this.paymentDetails = data;
  
            if (data.data === 'CAPTURED') {
              this.success = true;
              this.statusMessage = '🎉 Payment successful. You are now registered!';
            } else {
              this.success = false;
              this.statusMessage = `⚠️ Payment status: ${data.status}`;
            }
          },
          error: () => {
            this.success = false;
            this.statusMessage = '❌ Payment verification failed. Please contact support.';
          },
        });
      } else {
        this.success = false;
        this.statusMessage = '❌ Missing payment details.';
      }
    });
  }
  
}
